<template>
  <div class="associatedAccount_box">
    <div class="associated_list_box">
      <p class="bindAccountsTips">{{$t('home.bindAccountsTips')}}</p>
      <ul class="associated_list">
        <li class="associated_item clearfix"
            v-for="(item,index) in accounts"
            :key="index">
          <div class="associated_item_left clearfix"> <span class="icon">
              <img :src="item.icon"
                   alt="">
            </span>
            <span class="name">{{item.name}}</span>
          </div>
          <div class="associated_item_right clearfix"><span class="account_name">{{item.account_name}}</span>
            <span :class="item.binded==1?'btn':'btn_active'"
                  @click="item.binded==1?cancelSanfang(item.login_way_id):bindSanfang(item.loginType)">
              <!-- 解绑 -->
              {{item.binded==1?$t('bindAccountText.text1'):$t('bindAccountText.text2')}}
            </span>
          </div>
        </li>
      </ul>
      <div class="line"></div>
      <div class="associated_item clearfix">
        <div class="associated_item_left clearfix"> <span class="icon">
            <img :src="imgSrc"
                 alt="">
          </span>
          <span class="name">{{name}}</span>
        </div>
        <div class="associated_item_right clearfix"><span class="account_name"></span>
          <router-link to="/bindAccount?id=tourist"> <span class="btn_active">
              {{$t('bindAccountText.text2')}}
            </span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import associatedList from './component/associateList'
import { unbind } from '@/api/hw'
import { appPostMessage } from '@/utils/communication'
import { getSessionStorage, getToken } from '@/utils/stage'
export default {
  mounted() {
    let that = this
    window['bindScuess'] = (url) => {
      that.bindScuess(url) // 这个也就是我定义的方法
    }
  },
  data() {
    return {
      accounts: [],
      name: '',
      associated_list: associatedList,
      imgSrc: require('../../assets/images/favicon.png'),
    }
  },
  created() {
    this.init()
    this.accountList()
  },
  methods: {
    init() {
      this.configData = JSON.parse(getSessionStorage('message'))

      if (getSessionStorage('zm') == 1) {
        this.name = this.$t('bindAccountText.text6').replace(
          'FUNDOLL',
          'Cat Fantasy'
        )
        this.imgSrc = require('../../assets/images/zm.png')
      } else {
        this.name = this.$t('bindAccountText.text6')
      }
    },
    accountList() {
      const accountStorage = JSON.parse(getSessionStorage('accountStorage'))
      const csrf_token = getToken('csrf_token')
      const data = {
        username: this.username,
        csrf_token: csrf_token,
        access_token: accountStorage.access_token,
      }
      const msg = Object.assign(
        JSON.parse(JSON.stringify(this.configData)),
        data
      )
      const login_ways = JSON.parse(
        getSessionStorage('accountStorage')
      ).login_ways
      login_ways.forEach((item) => {
        for (const i in this.associated_list) {
          if (this.associated_list[i].channel == item.loginType) {
            item['icon'] = this.associated_list[i].icon
            item['name'] = this.associated_list[i].name
            item['account_name'] = this.associated_list[i].account_name
            item['binded'] = this.associated_list[i].binded
          }
        }
      })
      this.accounts = login_ways
      //   })
    },
    bindSanfang(channelId) {
      const msg = {
        code: 13,
        data: { loginType: channelId },
      }
      appPostMessage(msg)
    },
    cancelSanfang(channelId) {
      const accountStorage = JSON.parse(getSessionStorage('accountStorage'))

      const data = {
        csrf_token: csrf_token,
        access_token: accountStorage.access_token,
        login_way_id: channelId,
      }
      const msg = Object.assign(
        JSON.parse(JSON.stringify(this.configData)),
        data
      )
      unbind(msg).then((res) => {})
    },
    bindScuess(data) {
      console.log('绑定成功了！', data)
      this.$router.push({ path: '/success', query: { id: 7 } })
    },
    verifyFail() {
      const csrf_token = getToken('csrf_token')
      if (!csrf_token) {
        this.$toast(this.$t('toast.longTime'))
        return
      }
    },
  },
}
</script>

<style lang="less" scope>
.associatedAccount_box {
  padding: 30/75rem;
  box-sizing: border-box;
  .bindAccountsTips {
    font-size: 24/75rem;
    font-weight: 400;
    color: #575757;
    margin: 30/75rem 0;
  }
  .associated_list_box {
    .associated_item {
      width: 100%;
      margin-bottom: 30/75rem;
      .line {
        width: 630/75rem;
        height: 1px;
        border-top: 1/75rem solid#c7c7c7;
        margin: 0 auto;
        margin-bottom: 30/75rem;
      }
      span {
        display: inline-block;
        float: left;
        font-size: 28/75rem;
        height: 80/75rem;
        line-height: 80/75rem;
      }
      .icon {
        width: 80/75rem;
        height: 80/75rem;
      }
      .name {
        font-weight: bold;
        color: #575757;
        margin-left: 20/75rem;
      }
      .account_name {
        font-weight: 500;
        color: #c7c7c7;
      }
      .btn {
        width: 153/75rem;
        height: 55/75rem;
        background: #f2f3f4;
        border-radius: 28/75rem 28/75rem 28/75rem 28/75rem;
        color: #454545;
        font-size: 26/75rem;
        text-align: center;
        line-height: 55/75rem;
        margin-top: 12/75rem;
        margin-left: 10/75rem;
      }
      .btn_active {
        width: 153/75rem;
        height: 55/75rem;
        color: #ff7391;
        border: 1px solid #ff7391;
        border-radius: 28/75rem 28/75rem 28/75rem 28/75rem;
        font-size: 26/75rem;
        text-align: center;
        line-height: 55/75rem;
        margin-top: 12/75rem;
        margin-left: 10/75rem;
        background: none;
      }
      .associated_item_right {
        float: right;
      }
      .associated_item_left {
        float: left;
      }
      //   .fundoll_btn {
      //     border-top: 1px solid #c7c7c7;
      //   }
    }
    .line {
      width: 630/75rem;
      height: 0px;
      opacity: 1;
      border: 1px solid #c7c7c7;
      margin: 0 auto;
      margin-bottom: 30/75rem;
    }
  }
}
</style>